import { useEffect } from 'react';
import { FlexGrid, Button, Typography, useDialog, useThemeProvider, Card, Skeleton, Separator } from '@albo-ui/core'
import { BatchNotificationsProps, CouponsProps } from './types';
import { useNotificationsTable } from './hooks/useNotificationsTable';
import DataTable from 'react-data-table-component';
import { customStyles2 } from '../../../util/TableStyles'
import { noDataComponent, statusBatchConfig, batchResult } from '../../../util/DataObject'
import { paginationComponentOptions } from '../../../util/i18n-es';
import { Search, SettingsSuggest } from '@mui/icons-material';
import { IconButton, TextField, MenuItem } from '@mui/material';
import { CreateBatch } from '../../modals/batch-notifications/CreateBatch';
import { useBatchResult } from '../../modals/batch-notifications';

export const BatchNotifications = ({ changeAlert, changeLoader, sectionData }: BatchNotificationsProps) => {
    
    const { theme } = useThemeProvider();
    const { columns, data, loading: loadingTable, loading: loadingUpdate, search, disabledSearch, batchProcess, onHandleListStatus, onCreateConfig, saveData, onHandleChange, onHandleSearch, closeBatchDialog } = useNotificationsTable(changeAlert)
    const dialogProps = useDialog()

    const { DialogBatch, openDialog } = useBatchResult(
		`Batch ${search.batch_uuid}`, batchProcess, closeBatchDialog
	);

    const onCreateNotification = async (data: CouponsProps) => {
        dialogProps.onClose()
        onCreateConfig(data)
    }
    const onCloseDialogBatch = () => {
        dialogProps.onClose()
    }
    const onOpenDialogBatch = () => {
        dialogProps.openDialog()
    }

    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable])
    useEffect(() => {
        changeLoader(loadingUpdate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate])

    useEffect(() => {
        batchProcess && openDialog()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [batchProcess])
    useEffect(() => {
        saveData(sectionData)
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Card padding={5} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee, margin: 3 }}> 
            <FlexGrid container fullWidth justify='space-between' style={{ display: 'flex', marginBottom: 25 }}>
                <FlexGrid item>
                    <Typography variant='h2' style={{display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem'}}>
                        <SettingsSuggest sx={{ marginRight: 1 }}/> Configuración de Notificaciones
					</Typography>
                </FlexGrid>
                <FlexGrid item container spacing={2} style={{width: '30%', justifyContent: 'end'}}>
                    <Button buttonType='secondary' size='normal' onClick={onOpenDialogBatch}>Crear configuración</Button>
                </FlexGrid>
            </FlexGrid>

            <FlexGrid container spacing={2} style={{width: '50%', marginBottom: 25}}>
                <TextField select value={search['status'] || -1} onChange={onHandleListStatus.bind(this)} defaultValue={-1} size='small' fullWidth color='secondary'>
                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                    <MenuItem value={''} >Todos</MenuItem>
                    { statusBatchConfig.map((item, index) => {
                        return <MenuItem key={`status-${index}`} value={item.value}>{item.label}</MenuItem>
                    })}
                </TextField>
                <FlexGrid item fullWidth>
                    <TextField label={'Batch UUID'} value={search['batch_uuid']} onPaste={onHandleChange.bind(this, 'batch_uuid')} onChange={onHandleChange.bind(this, 'batch_uuid')} size='small' fullWidth color='secondary'/>
                </FlexGrid>
                <IconButton disabled={disabledSearch} onClick={onHandleSearch.bind(this)} sx={{padding: '0 !important'}}><Search sx={{padding: '6px', borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: disabledSearch? '#ccc' : '#8bc179' }}/></IconButton>
            </FlexGrid>

            { data.length === 0 && <Separator orientation='horizontal' style={{minHeight: 4, maxHeight: 4}} />}
            <FlexGrid container spacing={2} style={{margin: '25px 0' }}>
                {
                    loadingTable ?
                        <Skeleton width='100%' height='100px' />
                        :
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            paginationComponentOptions={paginationComponentOptions}
                        />
                }
            </FlexGrid>
            <CreateBatch onClose={onCloseDialogBatch} open={dialogProps.open} onConfirm={onCreateNotification.bind(this)} title={'Crear Notificación'} changeAlert={changeAlert} />
            {batchResult && <DialogBatch/>}
        </Card>
    )
}

